import { cn } from "../cn";

type Tone =
  | "neutral"
  | "primary"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "progress"
  | "done";

/**
 * Solid tone -> background-color class map. Exported so other components
 * that render their own tone-colored fills (e.g. the dashboard's
 * StatusDistributionBar segments/legend dots) share this single mapping
 * instead of duplicating it.
 */
export const statusDotToneClasses: Record<Tone, string> = {
  neutral: "bg-muted-foreground",
  primary: "bg-primary",
  success: "bg-success",
  warning: "bg-warning",
  danger: "bg-destructive",
  info: "bg-info",
  progress: "bg-progress",
  done: "bg-done",
};

interface StatusDotProps {
  tone?: Tone;
  pulse?: boolean;
  className?: string;
}

/** Small colored dot, optionally pulsing, for status indicators. */
export function StatusDot({
  tone = "neutral",
  pulse = false,
  className,
}: StatusDotProps) {
  return (
    <span className={cn("relative inline-flex size-2.5 shrink-0", className)}>
      {pulse && (
        <span
          className={cn(
            "absolute inline-flex size-full animate-ping rounded-full opacity-60",
            statusDotToneClasses[tone],
          )}
        />
      )}
      <span
        className={cn(
          "relative inline-flex size-full shrink-0 rounded-full",
          statusDotToneClasses[tone],
        )}
      />
    </span>
  );
}
